import React from 'react'
import { connect } from 'react-redux'
import c from 'classnames'

import { ValueSelector } from 'discada/dist/Form'
import Collection from 'components/widgets/Collection'

import { getAvailableSurveyValues } from 'selectors/quoteSelectors'

export class DefaultSection extends React.Component {
  constructor(...args) {
    super(...args)

    this.state = {
      open: false,
    }

    this.toggle = () => {
      this.setState({ open: !this.state.open })
    }
  }

  static getDerivedStateFromProps(nextProps, oldState) {
    return { ...oldState, ...nextProps }
  }

  render() {
    let {
      label,
      selected,
      collectionHeaders,
      values = [],
      addItem = () => {},
      removeItem = () => {},
      itemRenderer = () => {},
      onChange = () => {},
      onCustomChange = () => {},
      className,
      withConfig,
      allowCustom,
      customFieldLabel,
      onCustomClose,
      onCustomBlur,
      open,
      showDiff,
      children,
    } = this.state

    return (
      <div
        className={c('value-selector-wrapper', 'default-section', className, {
          'default-section-open': withConfig && open,
          'default-section-with-config': withConfig,
        })}
      >
        <p className="value-selector-label">{label}</p>
        {(!withConfig || !open) &&
          (values.length ? (
            <ValueSelector
              values={values}
              selected={selected}
              onChange={onChange}
              onCustomChange={onCustomChange}
              onCustomBlur={onCustomBlur}
              allowCustom={allowCustom}
              customFieldLabel={customFieldLabel}
              onCustomClose={onCustomClose}
              labelRenderer={v => (!showDiff ? v.label : v.diffLabel)}
              size="small"
            />
          ) : (
            <span className="empty">No options avalable</span>
          ))}

        {withConfig && open && itemRenderer && (
          <Collection
            headers={collectionHeaders}
            className={c('quote-config-collection')}
            items={values}
            addItem={addItem}
            removeItem={removeItem}
            itemRenderer={itemRenderer}
          />
        )}

        {withConfig && (
          <p className="default-section-toggler">
            {!open && <span onClick={this.toggle}>Add/Remove Options</span>}
            {open && <span onClick={this.toggle}>Close</span>}
          </p>
        )}

        {children && <div className="default-section-children">{children}</div>}
      </div>
    )
  }
}

function mapStateToProps(state, op) {
  return {
    ...op,
    values:
      op.values ||
      getAvailableSurveyValues(
        state,
        op.vehicleId,
        op.quoteId,
        op.mode,
        op.valueKey,
        op.valuesKey,
      ),
  }
}

export default connect(mapStateToProps)(DefaultSection)
